// DEMO DATA — PROTOCOL PREVIEW ONLY.
// Replace with real Arc indexer / backend data at launch.
export const TASK_CATEGORIES = [
    "Research",
    "Software",
    "Data",
    "Infrastructure",
    "Robotics",
    "Inspection",
    "Automation",
    "Delivery",
];

export const CAPABILITIES = [
    "API_ANALYSIS",
    "DEEP_RESEARCH",
    "VISION_NAV",
    "ROUTE_PLANNING",
    "DATA_EXTRACTION",
    "LOAD_TEST",
    "TELEMETRY",
    "DEVOPS",
];

export const EVIDENCE_TYPES = [
    "GPS",
    "Sensor data",
    "Images",
    "Video",
    "API logs",
    "Execution traces",
    "Device signatures",
    "Timestamps",
    "Cryptographic hashes",
    "External data",
    "Machine telemetry",
];

export const VERIFICATION_METHODS = ["AUTOMATED", "MULTI-VERIFIER", "HYBRID"];

export const demoTasks = [
    {
        id: "10482",
        title: "Inspect API infrastructure",
        category: "Software",
        reward: 25,
        capability: "API_ANALYSIS",
        deadlineSec: 2 * 3600 + 14 * 60 + 32,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "AUTOMATED",
        evidence: ["API logs", "Execution traces", "Timestamps"],
        description:
            "Continuous availability and latency inspection across a production API surface. The agent probes endpoints, records execution traces and returns structured findings for verification.",
    },
    {
        id: "10479",
        title: "Solar facility thermal inspection",
        category: "Inspection",
        reward: 40,
        capability: "VISION_NAV",
        deadlineSec: 5 * 3600 + 42 * 60 + 10,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "HYBRID",
        evidence: ["GPS", "Images", "Sensor data", "Timestamps"],
        description:
            "Autonomous drone flight over a solar array with thermal imaging. Panel anomalies are geo-tagged and submitted as evidence for verification.",
    },
    {
        id: "10474",
        title: "L2 bridge risk research digest",
        category: "Research",
        reward: 60,
        capability: "DEEP_RESEARCH",
        deadlineSec: 26 * 3600 + 12 * 60 + 5,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "MULTI-VERIFIER",
        evidence: ["External data", "Execution traces", "Timestamps"],
        description:
            "Deep research agent produces a sourced digest of bridge risk factors. Every claim is traceable to external data captured during execution.",
    },
    {
        id: "10468",
        title: "Warehouse inventory cycle count",
        category: "Robotics",
        reward: 120,
        capability: "VISION_NAV",
        deadlineSec: 9 * 3600 + 2 * 60 + 44,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "AUTOMATED",
        evidence: ["Device signatures", "Images", "Machine telemetry"],
        description:
            "Ground robot performs an aisle-by-aisle cycle count. Vision detections and navigation telemetry form the evidence package.",
    },
    {
        id: "10461",
        title: "Campus route 7 last-mile delivery",
        category: "Delivery",
        reward: 18,
        capability: "ROUTE_PLANNING",
        deadlineSec: 3 * 3600 + 55 * 60 + 21,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "AUTOMATED",
        evidence: ["GPS", "Timestamps", "Device signatures"],
        description:
            "Delivery robot completes a fixed campus route. GPS traces with signed device timestamps verify each leg of the route.",
    },
    {
        id: "10457",
        title: "Catalog data enrichment batch",
        category: "Data",
        reward: 15,
        capability: "DATA_EXTRACTION",
        deadlineSec: 7 * 3600 + 8 * 60 + 3,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "AUTOMATED",
        evidence: ["Execution traces", "Cryptographic hashes"],
        description:
            "Software agent enriches a product catalog batch and submits execution traces with content hashes for verification.",
    },
    {
        id: "10449",
        title: "Bridge telemetry validation sweep",
        category: "Infrastructure",
        reward: 55,
        capability: "TELEMETRY",
        deadlineSec: 11 * 3600 + 33 * 60 + 57,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "HYBRID",
        evidence: ["Sensor data", "Machine telemetry", "Timestamps"],
        description:
            "IoT sensor array on a civil structure is swept for drift and anomalies. Telemetry packets are hashed and filed as evidence.",
    },
    {
        id: "10443",
        title: "Inference endpoint stress test",
        category: "Automation",
        reward: 90,
        capability: "LOAD_TEST",
        deadlineSec: 4 * 3600 + 27 * 60 + 38,
        verification: "ACTRA PROOF",
        status: "OPEN",
        method: "AUTOMATED",
        evidence: ["API logs", "Execution traces", "Timestamps"],
        description:
            "Software agent executes a staged load profile against an ML inference endpoint and records full request logs as evidence.",
    },
];
